import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { matchPath } from 'react-router';
import moment from 'config/Moment';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Creators as InterviewsActions } from 'store/ducks/interviews';
import { Creators as JourneysActions, Selectors as JourneysSelectors } from 'store/ducks/journeys';

import { Validate } from 'common';
import { Page, Panel, Button, Loading } from 'components';
import { Form } from 'pages/Admin/Interviews/components';

class Edit extends Component {
  state = {
    data: {
      name: '',
      course: '',
      course_class: '',
      calculated_at: null,
      journey: {},
      coach_email: null,
      blind_participant: false,
    },
    errors: {},
  };

  componentDidMount() {
    const { getJourneysRequest, getInterviewRequest } = this.props;

    getInterviewRequest(this.handleGetID());
    getJourneysRequest();
  }

  componentDidUpdate(oldProps) {
    const { data } = this.state;
    const { interview, journeys } = this.props;

    if (oldProps.interview.loading && !interview.loading) {
      this.setState({
        data: {
          ...data,
          name: interview.data.attributes.person.name,
          course: interview.data.attributes.course,
          course_class: interview.data.attributes.course_class,
          calculated_at: new Date(interview.data.attributes.calculated_at),
          coach_email: interview.data.attributes.coach_email,
          blind_participant: !interview.data.attributes.blind_participant,
          journey: {
            value: {
              key: interview.data.attributes.interviewable.id,
              type: interview.data.attributes.interviewable_type,
            },
            label: interview.data.attributes.interviewable.title,
          },
        },
      });
    }
  }

  handleGetID = () => {
    const match = matchPath(this.props.location.pathname, { path: '/admin/interviews/:id/edit' });
    return match.params.id;
  };

  handleChange = data => {
    this.handleValidate();
    this.setState({ data });
  };

  handleValidate = () => {
    const { data } = this.state;

    if (data.coach_email === '') {
      data.coach_email = null;
    }

    const rules = {
      course: {
        required: true,
      },

      course_class: {
        required: true,
      },

      calculated_at: {
        required: true,
      },

      coach_email: {
        email: true
      },
    };

    const validate = Validate(data, rules);
    this.setState({ errors: validate.errors });

    return validate.valid;
  };

  handleSubmit = e => {
    e.preventDefault();

    if (!this.handleValidate()) return null;

    const { data } = this.state;

    const { updateInterviewRequest } = this.props;

    updateInterviewRequest(this.handleGetID(), {
      interview: {
        course: data.course,
        course_class: data.course_class,
        calculated_at: moment(data.calculated_at).format('YYYY-MM-DD HH:mm'),
        coach_email: data.coach_email,
        blind_participant: !data.blind_participant
      },
    });
  };

  render() {
    const { data, errors } = this.state;
    const { update, interview } = this.props;

    return (
      <Page>
        <div className="row align-items-center">
          <div className="col-6">
            <Page.Title>Editar Entrevista</Page.Title>
          </div>

          <div className="col-6 text-right">
            <Button type="success" onClick={this.handleSubmit} disabled={update.loading || interview.loading}>
              {update.loading ? <Loading type="btn" size="small" text="Salvando..." /> : 'Salvar'}
            </Button>

            <Link to="/admin/interviews" className="btn btn-danger m-l-10">
              Cancelar
            </Link>
          </div>
        </div>

        <Panel>
          <Form isUpdate data={data} errors={errors} onChange={this.handleChange} onSubmit={this.handleSubmit} />
        </Panel>
      </Page>
    );
  }
}

const mapState = state => ({
  interview: state.interviews.interview,
  update: state.interviews.update,
  journeys: {
    ...state.journeys,
    data: JourneysSelectors.search(state.journeys.data),
  },
});

const mapActions = dispatch => bindActionCreators({ ...InterviewsActions, ...JourneysActions }, dispatch);

export default connect(
  mapState,
  mapActions,
)(Edit);



// WEBPACK FOOTER //
// ./src/pages/Admin/Interviews/Edit/index.js